import React, { useContext, useEffect, useRef, useState } from "react"
import { makeStyles } from "@mui/styles"
import Popover from "@mui/material/Popover"

import Badge from "@mui/material/Badge"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"

import { useHistory } from "react-router-dom"

import notifySound from "../../assets/chat_notify.mp3"
import useSound from "use-sound"
import { Icon } from "@iconify/react/dist/iconify.js"
import api from "../../services/api"

import { formatRelative } from "date-fns"
import { ptBR } from "date-fns/locale"
import { SocketContext } from "../../context/Socket/SocketContext"

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        maxHeight: 300,
        maxWidth: 500,
        padding: theme.spacing(1),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
}))

const ListItemComponent = ({ name, form, time, handleClick }) => {
    return (
        <ListItem
            sx={{ gap: 2, justifyContent: "space-between", cursor: "pointer" }}
            divider
            onClick={handleClick}
        >
            <Box display="flex" flexDirection="column">
                <Typography variant="subtitle1">{name}</Typography>
                <Typography
                    variant="caption"
                    sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {form}
                </Typography>
            </Box>
            <Box>
                <Typography variant="caption">
                    {formatRelative(time, new Date(), { locale: ptBR })}
                </Typography>
            </Box>
        </ListItem>
    )
}

export default function LeadsPopover() {
    const { socket } = useContext(SocketContext)
    const classes = useStyles()
    const history = useHistory()
    const [anchorEl, setAnchorEl] = useState(null)
    const [invisible, setInvisible] = useState(true)
    const [leads, setLeads] = useState([])

    const [play] = useSound(notifySound)
    const soundAlertRef = useRef()

    const open = Boolean(anchorEl)
    const id = open ? "simple-popover" : undefined

    async function getLeads() {
        try {
            const response = await api.get("/lead/new")

            setLeads(response.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (open) {
            getLeads()
        }
    }, [open])

    useEffect(() => {
        if (socket?.connected) {
            socket.emit("joinLeads")
        }
    }, [socket])

    useEffect(() => {
        const companyId = localStorage.getItem("companyId")

        socket.on(`company-${companyId}-lead`, (data) => {
            if (data.action === "create") {
                setLeads([data.lead, ...leads])
                soundAlertRef.current()
            }

            if (data.action === "markAsRead") {
                setLeads(
                    leads.map((item) =>
                        item.id === id ? { ...item, viwed: true } : item,
                    ),
                )

                getLeads()
            }
        })
    }, [socket])

    useEffect(() => {
        soundAlertRef.current = play

        if (!("Notification" in window)) {
            console.log("This browser doesn't support notifications")
        } else {
            Notification.requestPermission()
        }
    }, [play])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
        setInvisible(true)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleNavigate = () => {
        history.push(`/leads`)
    }

    return (
        <div>
            <IconButton
                aria-describedby={id}
                variant="contained"
                color={invisible ? "default" : "inherit"}
                onClick={handleClick}
                style={{ color: "white" }}
            >
                <Badge
                    color="success"
                    invisible={leads.length <= 0}
                    badgeContent={leads.length}
                >
                    <Icon icon="mdi:leads-outline" />
                </Badge>
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <Paper variant="outlined" className={classes.mainPaper}>
                    <List
                        dense
                        component="nav"
                        aria-label="main mailbox folders"
                        style={{ minWidth: 300 }}
                    >
                        {!!Array.isArray(leads) &&
                            leads.map((item) => (
                                <ListItemComponent
                                    key={item.id}
                                    form={
                                        item.formResponses?.[0]?.question?.form
                                            .title
                                    }
                                    name={item.name}
                                    time={item.createdAt}
                                    profilePicUrl={item.profilePicUrl}
                                    handleClick={handleNavigate}
                                />
                            ))}
                        {Array.isArray(leads) && leads.length === 0 && (
                            <ListItemText primary="Nenhum registro" />
                        )}
                    </List>
                </Paper>
            </Popover>
        </div>
    )
}
